import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { monitor } from '@/utils/monitor';
export default {
  setup() {
    const {
      locale
    } = useI18n();
    const toIndexPage = () => {
      window.location.href = `/${locale.value}/trade/spot/`;
    };

    // 上报404页面访问数据
    onMounted(() => monitor.counter('metric_trade_page_404'));
    return {
      toIndexPage
    };
  }
};